import { Component, OnInit, forwardRef } from '@angular/core';
import { NavController, NavParams, ModalController, IonicModule } from '@ionic/angular';
import { GrupoCheckPessoaDetalhesPage } from '../grupo-check-pessoa-detalhes/grupo-check-pessoa-detalhes.page';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-grupo-check-responsavel',
  templateUrl: './grupo-check-responsavel.page.html',
  styleUrls: ['./grupo-check-responsavel.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule
  ],
})

export class GrupoCheckResponsavelPage implements OnInit {
  pessoa: any = {};
  responsaveis: any = [];
  isMenor: boolean = false;
  idReuniao: any = "";

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
  ) {
    this.pessoa = navParams.get('pessoa');
    this.responsaveis = navParams.get('responsaveis');
    this.isMenor = navParams.get('isMenor');
    this.idReuniao = this.navParams.get('idReuniao');
  }

  ngOnInit() {
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  async selecionar(responsavel: any) {
    const modalPage = await this.modalCtrl.create({ component: GrupoCheckPessoaDetalhesPage, componentProps: { pessoa: this.pessoa, responsavel: responsavel, isMenor: this.isMenor, idReuniao: this.idReuniao } });
    modalPage.present();

    const data = (await modalPage.onWillDismiss())
    if (data) {
      this.modalCtrl.dismiss(true);
    }
  }
}
